import type { UserPublic } from "@eduviaos/shared";
import { api } from "../api";
import type { SignedUploadResponse } from "../learning/types";

export async function mintAvatarUploadUrl(body: {
  content_type: string;
  file_size: number;
}): Promise<SignedUploadResponse> {
  return api.post<SignedUploadResponse>("/auth/me/avatar/upload-url", body);
}

export async function commitAvatar(avatarUrl: string): Promise<UserPublic> {
  return api.put<UserPublic>("/auth/me/avatar", { avatar_url: avatarUrl });
}

export async function putFileToSignedUrl(signed: SignedUploadResponse, file: File): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", signed.put_url);
    for (const [k, v] of Object.entries(signed.required_headers)) {
      xhr.setRequestHeader(k, v);
    }
    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(`Upload failed: ${xhr.status}`));
    });
    xhr.addEventListener("error", () => reject(new Error("Network error during upload.")));
    xhr.send(file);
  });
}
